export const CreateCaptcha = (id) => {
    document.getElementById(id).innerHTML = "";
    let charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let lenghtOfcaptcha = 5;
    let captcha = [];

    for (let i = 0; i < lenghtOfcaptcha; i++) {
        let index = Math.floor(Math.random() * charsArray.length + 1);

        if (captcha.indexOf(charsArray[index]) === -1){
            captcha.push(charsArray[index]);
        }else{
            i--;
        }
    }

    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 100;
    canv.height = 50;
    let ctx = canv.getContext("2d");
    ctx.font = "20px sans-serif"
    ctx.strokeText(captcha.join(""), 0, 30);
    let code = captcha.join("");
    document.getElementById(id).appendChild(canv); // adds the canvas to the body element

    return code;
}
